import { createFileRoute } from '@tanstack/react-router'
import { EstimatePrintPage } from '../../../../../features/service/estimate-print-page'
import { serviceJobQueryOptions } from '../../../../../features/service/queries'

export const Route = createFileRoute('/_app/service/jobs/$jobId/estimate')({
  staticData: { crumb: 'serviceEstimate' },
  loader: ({ context, params }) => context.queryClient.ensureQueryData(serviceJobQueryOptions(params.jobId)),
  component: EstimatePrintPage,
})
